// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__lnKPK","wrapper":"Checkbox_wrapper__BsmyV","input":"Checkbox_input__NjLRR","icon":"Checkbox_icon__tSN0K","true":"Checkbox_true__7UQdv"};